import { makeStyles } from '@mui/styles';
import { grey, orange } from '@mui/material/colors';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(2)
  },
  fullWidthDiv: {
    flexGrow: 1
  },
  rootActions: {
    flexGrow: 1,
    marginTop: theme.spacing(2),
    textAlign: 'right'
  },
  card: {
    position: 'relative',
    textAlign: 'center',
    margin: 10,
    marginBottom: 20,
    border: '1px solid rgba(0, 0, 0, 0.12)',
    boxShadow: 'unset',
    padding: 20
  },
  icon: {
    position: 'absolute !important',
    right: 10,
    top: 10,
    zIndex: 1
  },
  divider: {
    marginTop: 10
  },
  body: {
    paddingTop: 20,
    textAlign: 'left'
  },
  actions: {
    bottom: 10,
    right: 10,
    padding: 0,
    textAlign: 'right'
  },
  selectContainer: {
    transform: 'translateY(-13px)',
    width: '100%'
  },
  select: {
    width: '131px'
  },
  button: {
    marginLeft: 2,
    marginRight: 2
  },
  clearFix: {
    clear: 'both',
    display: 'table'
  },
  gutterBottomCardRow: {
    marginBottom: 15,
    textAlign: 'left'
  },
  flexAuto: {
    flexBasis: 'auto',
    marginRight: '10px',
  },
  rootSubCard: {
    minWidth: 275,
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: grey[50],
    width: '100%'
  },
  titleSubCard: {
    textAlign: 'left',
    fontSize: 14
  },
  subHeaderSubCard: {
    textAlign: 'left',
    fontSize: 11
  },
  btnVrtOn: {
    fontSize: 11,
    color: 'white'
  },
  btnVrt: {
    fontSize: 11,
    backgroundColor: 'white',
    color: '#ff9800'
  },
  wrapperTextButtonSubCard: {
    marginLeft: 5
  },
  textButtonSubCard: {
    lineHeight: '12px',
    color: grey[600]
  },
  selectText: {
    fontSize: 11
  },
  cardContent: {
    paddingTop: 0,
    paddingBottom: 0
  },
  expansionPanelSummary: {
    backgroundColor: orange[100]
  },
  expansionPanel: {
    backgroundColor: grey[50],
    marginTop: 5
  },
  expansionPanelDetails: {
    borderStyle: 'solid',
    borderWidth: 0.5,
    borderColor: grey[300]
  },
  '@global': {
    '.MuiCardContent-root:last-child': {
      paddingBottom: 0
    },
    '.Mui-expanded': {
      marginTop: 5
    }
  }
}));

export default useStyles;
